module.exports = __webpack_public_path__ + "img/caret.18856fc6.svg";